// extracted by mini-css-extract-plugin
export default {"Preview":"Preview_Preview__WvWkR","PreviewBorders":"Preview_PreviewBorders__7LyQN","FramePreview":"Preview_FramePreview__0XTaj"};